export enum BookingsVisibility {
  All = "all",
  CurrentZoom = "currentZoom"
}
